import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    if (!value) return '';

    let html = value;

    // Add target="_blank" + rel to all anchor tags
    html = html.replace(
      /<a\s+([^>]*href="[^"]+"[^>]*)>/gi,
      (match, group1) => {
        // If target already exists, leave it alone
        if (/target\s*=/.test(group1)) {
          return `<a ${group1}>`;
        }
        return `<a ${group1} target="_blank" rel="noopener noreferrer">`;
      }
    );

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
